import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { NonExchangeDayFilters } from '../../../../app/models/NonExchangeDay';

type Props = {
    filter: NonExchangeDayFilters;
    setFilter: (filter: NonExchangeDayFilters) => void;
};

const NonExchangeDayFilter = ({ filter, setFilter }: Props) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value
        });
    };

    return (
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label>Nombre</label>
                        <input type="text" name="name"
                            className="form-control form-control-sm"
                        
                        value={filter.name || ''} onChange={handleChange} />
                    </div>
                </div>
                <div className="col-md-auto">
                        <label>Período</label>
                        <select name="period" 
                            className="form-control form-select-sm"
                        
                        value={filter.period || ''} onChange={handleChange}>
                        
                            <option value="">Todos</option>
                            <option value="No repite">No repetir</option>
                            <option value="Semanal">Semanal</option>
                            <option value="Anual">Anual</option>
                        </select>
                </div>
            </div>
    );
};

export default NonExchangeDayFilter; 